import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import FloatingTabBar from "./components/FloatingTabBar";
import WelcomePage from "./pages/WelcomePage";
import OTPVerificationWrapper from "./pages/OTPVerificationWrapper";
import EmailVerificationPage from "./pages/EmailVerificationPage";
import PANDetailsPage from "./pages/PANDetailsPage";
import Dashboard from "./pages/Dashboard";
import LoanApplicationPage from "./pages/LoanApplicationPage";
import ProfilePage from "./pages/ProfilePage";
import LoadingSpinner from "./components/LoadingSpinner";

function App() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // Data-driven routing — relies on fields the backend actually persists,
  // not on flag fields (google_signin_completed / empanelment_completed)
  // that the backend ignores on profile PUT.
  const hasEmail = !!user?.email;
  const hasName = !!user?.full_name;
  const onboardingComplete = hasEmail && hasName;

  return (
    <div className="min-h-screen bg-black">
      <Routes>
        {/* ── Unauthenticated-only routes ── */}
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <WelcomePage />
          }
        />
        <Route
          path="/otp-verification"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <OTPVerificationWrapper />
            )
          }
        />

        {/* ── Onboarding: step 1 — email verification ── */}
        <Route
          path="/email-verification"
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : onboardingComplete ? (
              <Navigate to="/" replace />
            ) : hasEmail ? (
              <Navigate to="/pan-details" replace />
            ) : (
              <EmailVerificationPage />
            )
          }
        />

        {/* ── Onboarding: step 2 — PAN / personal details ── */}
        <Route
          path="/pan-details"
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : onboardingComplete ? (
              <Navigate to="/" replace />
            ) : !hasEmail ? (
              <Navigate to="/email-verification" replace />
            ) : (
              <PANDetailsPage />
            )
          }
        />

        {/* ── Authenticated app routes — no sidebar, centered 400px ── */}
        <Route
          path="/*"
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : !onboardingComplete ? (
              <Navigate
                to={!hasEmail ? "/email-verification" : "/pan-details"}
                replace
              />
            ) : (
              <>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route
                    path="/loan-application"
                    element={<LoanApplicationPage />}
                  />
                  <Route
                    path="/profile"
                    element={
                      <div
                        className="min-h-screen bg-gray-50"
                        style={{ maxWidth: "400px", margin: "0 auto" }}
                      >
                        <ProfilePage />
                      </div>
                    }
                  />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <FloatingTabBar />
              </>
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;
